module.exports = __webpack_public_path__ + "img/20200513_161515.3d91e03d.jpg";